import { FILTER_TYPE } from '@intelligence/v3/filterControls/filterTypes';
import { GENRE_SOURCE_MAP } from '@intelligence/components/GenreSelect/constants';

import { PAGE_ID } from './constants';

import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';
import type { IGenreSourcesGenreOptions } from '@intelligence/components/GenreSelect/types';

interface IGetRobloxTopChartsFilterItemsParams {
  regionOptions: any[];
  genreOptions?: IGenreSourcesGenreOptions;
  genreOptionsLoading?: boolean;
  rangePickerComponentDefault?: Record<string, [string, string]>;
}

export const getRobloxTopChartsFilterItems = (
  params: IGetRobloxTopChartsFilterItemsParams,
): IFilterItemConfig[] => {
  const {
    regionOptions,
    genreOptions = {},
    genreOptionsLoading = false,
    rangePickerComponentDefault,
  } = params;

  return [
    {
      type: FILTER_TYPE.RANGE_PICKER,
      field: 'date',
      controlProps: {
        showSelectType: true,
        typeList: ['date', 'week', 'month'],
        showShortcut: true,
        componentDefault: rangePickerComponentDefault,
      },
      inherit: ['all'],
    },
    {
      type: FILTER_TYPE.RANGE_PICKER,
      field: 'releaseTime',
      apiParamsFieldMapResolver: () => ({
        startDate: 'start_release_date',
        endDate: 'end_release_date',
      }),
      urlParamsFieldMapResolver: () => ({
        startDate: 'startReleaseDate',
        endDate: 'endReleaseDate',
      }),
      controlProps: {
        showSelectType: false,
        typeList: ['date'],
        showShortcut: true,
      },
      inherit: ['all'],
    },
    {
      type: FILTER_TYPE.REGION_SELECT,
      field: 'region',
      controlProps: {
        options: regionOptions,
        entityType: 'mobile',
        tagNumber: 1,
        disableNoChina: true,
      },
      inherit: ['all'],
    },
    {
      type: FILTER_TYPE.GENRE_SELECT,
      field: 'genre',
      hoverTipsKey: 'dbi_roblox_genrefilter_info',
      controlProps: {
        sources: [GENRE_SOURCE_MAP.ROBLOX],
        allowEmptySources: true,
        genresOptionsData: genreOptions,
        genresOptionsDataLoading: genreOptionsLoading,
      },
      inherit: [PAGE_ID],
    },
  ];
};
